export default function range(one: number, two?: number) {
  const end = typeof two === 'number' ? two : one
  const start = typeof two === 'number' ? one : 0
  const arr = []
  for (let i = start; i < end; i = i + 1) {
    arr.push(i)
  }

  return arr
}
